import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box } from '@mui/material';
import Heading from '../../Components/Heading/heading.tsx';
import SearchIcon from '@mui/icons-material/Search';

interface FindWarehouseModalProps {
    open: boolean;
    onClose: () => void;
    searchWarehouseName: string;
    setSearchWarehouseName: (value: string) => void;
    searchError: string;
    searchResults: any[];
    handleSearchWarehouse: () => void;
    handleSelectExistingWarehouse: (warehouse: any) => void;
}

const FindWarehouseModal: React.FC<FindWarehouseModalProps> = ({
    open,
    onClose,
    searchWarehouseName,
    setSearchWarehouseName,
    searchError,
    searchResults,
    handleSearchWarehouse,
    handleSelectExistingWarehouse
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" >
             <Box sx={{ marginLeft: { xs: '0px', sm: '-180px' } }}>
            <Heading title="Find Existing Warehouses" closeIcon="true" onClose={onClose} /></Box>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TextField
                        label="Warehouse Name"
                        value={searchWarehouseName}
                        onChange={(e) => setSearchWarehouseName(e.target.value)}
                        placeholder="Enter warehouse name to search"
                        size="small"
                        onKeyPress={(e) => e.key === 'Enter' && handleSearchWarehouse()}
                    />
                </Box>

                {searchError && (
                    <Box sx={{ mt: 2, color: 'error.main' }}>
                        {searchError}
                    </Box>
                )}

                {searchResults.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                        {searchResults.length === 1 ? (
                            <Box sx={{ p: 2, backgroundColor: '#e8f5e8', border: '1px solid #4caf50', borderRadius: 1, mb: 1 }}>
                                <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#2e7d32' }}>
                                    ✓ Found one matching warehouse. Auto-filled the form.
                                </p>
                            </Box>
                        ) : (
                            <>
                                <p>Select a warehouse:</p>
                                {searchResults.map((warehouse) => (
                                    <Box
                                        key={warehouse.id}
                                        sx={{
                                            p: 2,
                                            border: '1px solid #ccc',
                                            borderRadius: 1,
                                            mb: 1,
                                            cursor: 'pointer',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                        onClick={() => handleSelectExistingWarehouse(warehouse)}
                                    >
                                        <strong>{warehouse.name}</strong><br />
                                        Client: {warehouse.client_name} <br />
                                        Contact: {warehouse.contact_name} | {warehouse.phone}
                                    </Box>
                                ))}
                            </>
                        )}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}
                    className="custom-cancel-button"
                    style={{ marginRight: '10px' }}>Cancel</Button>
                <Button
                    onClick={handleSearchWarehouse}
                    variant="contained"
                    disabled={!searchWarehouseName.trim()}
                    startIcon={<SearchIcon />}
                    className="custom-button"
                    style={{ marginLeft: '10px' }}
                >
                    Search
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FindWarehouseModal;
